import type { ReactNode } from 'react';
import styles from './styles.module.css';

type ISectionHeadProps = {
  title: string;
  /** The section's headline figures, right-aligned (absent while data is unavailable). */
  children?: ReactNode;
};

/** A card section's header row: the small uppercase title, and its figures on the right. */
export function SectionHead({ title, children }: ISectionHeadProps) {
  return (
    <div className={styles.head}>
      <span className={styles.title}>{title}</span>
      {children}
    </div>
  );
}
